export default "__VITE_ASSET__CCECYR2r__"